module.exports = __webpack_public_path__ + "static/img/server2.e44dae98.jpg";